/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Player_StyleInputs */

const en_mobile_player_style = /** @type {(inputs: Mobile_Player_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style`)
};

const es_mobile_player_style = /** @type {(inputs: Mobile_Player_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo`)
};

/**
* | output |
* | --- |
* | "Style" |
*
* @param {Mobile_Player_StyleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_player_style = /** @type {((inputs?: Mobile_Player_StyleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Player_StyleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_player_style(inputs)
	return en_mobile_player_style(inputs)
});